// Module
var code = `<!-- UserView -->
<div>
	<div></div>

	<div class="action-wrapper row m-0 mb-3">
		<div class="shortcut-actions col p-0">
			<button class="btn btn-sm btn-outline-dark shortcuts-toggle user">
				<i class="fa fa-user" title="translate('Toggle personal shortcuts')"></i>
			</button>
			<button class="btn btn-sm btn-outline-dark shortcuts-toggle team">
				<i class="fa fa-users" title="translate('Toggle team shortcuts')"></i>
			</button>
		</div>
	
		<div class="menu-actions d-flex col justify-content-end p-0">
			<div class="languages d-none">
				<button class="btn btn-secondary graphileon-bg-color d-flex align-items-center justify-content-center border border-2 graphileon-border-color circle p-0"
					type="button" data-bs-toggle="dropdown" aria-expanded="false">
					<i class="fa fa-language language" title="translate('Languages')"></i>
				</button>
				<ul class="dropdown-menu languages-menu"></ul>
			</div>
			<button class="info-icon btn btn-secondary graphileon-bg-color d-flex align-items-center justify-content-center border border-2 graphileon-border-color circle p-0 ms-1">
				<i class="fa-solid fa-info" title="translate('About Graphileon')"></i>
			</button>
			<button class="account-icon btn btn-outline-secondary graphileon-color d-flex align-items-center justify-content-center border border-2 graphileon-border-color circle p-0 ms-1">
				<span class="account-name bg-transparent" title="translate('Profile')"></span>
			</button>
		</div>
	</div>

	<div class="shortcuts">
		<div class="shortcuts-user shortcuts-section mt-1 d-none">
			<span class="shortcuts-section-icon d-inline-flex justify-content-center ms-1">
				<i class="fa fa-user" title="translate('User shortcuts')"></i>
			</span>
		</div>
		<div class="shortcuts-team shortcuts-section mt-1 d-none">
			<span class="shortcuts-section-icon d-inline-flex justify-content-center ms-1">
				<i class="fa fa-users" title="translate('Team shortcuts')"></i>
			</span>
		</div>
		<div class="shortcuts-dashboard shortcuts-section mt-1">
			<div class="dashboards mb-2 d-flex align-items-center form-control bg-secondary-subtle">
				<i class="fa fa-dashboard me-2" title="translate('Dashboard')"></i>
				<select id="dashboard-selector" class="dashboard-selector form-select w-100"></select>
			</div>
		</div>
	</div>
	<!-- /UserView -->
</div>
`;
// Exports
export default code;